import { ActionBase } from '../../../core/store/action/ActionBase';

export const UNLOCK_ACCOUNT = '[Customer] User Unlock Account';

export class UnlockAccountAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = UNLOCK_ACCOUNT;

  constructor(public payload: { user: { key: string, identifier: string } }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/UnlockAccountAction.ts